import { render, staticRenderFns } from "./dataandreports.vue?vue&type=template&id=41fd5f96&scoped=true&"
import script from "./dataandreports.vue?vue&type=script&lang=js&"
export * from "./dataandreports.vue?vue&type=script&lang=js&"
import style0 from "./dataandreports.vue?vue&type=style&index=0&id=41fd5f96&scoped=true&lang=css&"
import style1 from "./dataandreports.vue?vue&type=style&index=1&id=41fd5f96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd5f96",
  null
  
)

export default component.exports